import React from "react";
import { NavLink } from "react-router-dom";
import mainLogo from "../../../assets/images/main-logo.svg";
import { StyledLogoHomeHeaderWrapper } from "./styledHomePageHeaders";

const LogoHomeHeader = () => {
  return (
    <NavLink to="/">
      <StyledLogoHomeHeaderWrapper
        whileHover={{ rotate: -20 }}
      >
        <img
          src={mainLogo}
          alt="chat-logo"
        />
      </StyledLogoHomeHeaderWrapper>
    </NavLink>
  );
};

export default LogoHomeHeader;